import {get} from 'lodash';

export default (LABEL: {[key: string]: string}) => {
	const getLabel = (key:string) => get(LABEL, key, '');
	const required = true;

	const fields = {
		quoteRequest: {
			// TRIPS (DEFINED AT COMPONENT)

			// ACCOMODATION
			offerIncludesAccommodation: {
				type: 'CheckboxGroup',
				options: [
					{value: getLabel('quoteRequest.offerIncludesAccommodation.economy')},
					{value: getLabel('quoteRequest.offerIncludesAccommodation.comfort')},
					{value: getLabel('quoteRequest.offerIncludesAccommodation.premium')},
					{value: getLabel('quoteRequest.offerIncludesAccommodation.luxury')},
				],
				label: '',
				required,
			},

			// DATES
			duration: {
				type: 'TextInput',
			},

			timeFlexibility: {
				type: "Selectbox",
				options: [
					{value: getLabel('quoteRequest.timeFlexibility.0')},
					{value: getLabel('quoteRequest.timeFlexibility.1D')},
					{value: getLabel('quoteRequest.timeFlexibility.3D')},
					{value: getLabel('quoteRequest.timeFlexibility.7D')},
					{value: getLabel('quoteRequest.timeFlexibility.14D')},
					{value: getLabel('quoteRequest.timeFlexibility.1M')},
				],
				hasEmptyOption: false,
			},

			alternativeTimeFlexibility: {
				type: "Selectbox",
				options: [
					{value: getLabel('quoteRequest.timeFlexibility.0')},
					{value: getLabel('quoteRequest.timeFlexibility.1D')},
					{value: getLabel('quoteRequest.timeFlexibility.3D')},
					{value: getLabel('quoteRequest.timeFlexibility.7D')},
					{value: getLabel('quoteRequest.timeFlexibility.14D')},
				],
				hasEmptyOption: false,
			},

			// TRANSPORT
			offerIncludesTransportation: {
				type: 'CheckboxGroup',
				options: [
					{value: getLabel('quoteRequest.offerIncludesTransportation.train')},
					{value: getLabel('quoteRequest.offerIncludesTransportation.bus')},
					{value: getLabel('quoteRequest.offerIncludesTransportation.self')},
					{value: getLabel('quoteRequest.offerIncludesTransportation.plane')},
					{value: getLabel('quoteRequest.offerIncludesTransportation.longDistanceBus')},
				],
				label: '',
			},

			departureStation: {
				type: 'TextInput',
				required,
				maxLength: 80,
				watch: {
					name: 'quoteRequest.offerIncludesTransportation',
					value: getLabel('quoteRequest.offerIncludesTransportation.train'),
				},
			},

			departureAirport: {
				type: 'TextInput',
				required,
				maxLength: 80,
				watch: {
					name: 'quoteRequest.offerIncludesTransportation',
					value: getLabel('quoteRequest.offerIncludesTransportation.plane'),
				},
			},

			departureBusStation: {
				type: 'TextInput',
				required,
				maxLength: 80,
				watch: {
					name: 'quoteRequest.offerIncludesTransportation',
					value: getLabel('quoteRequest.offerIncludesTransportation.longDistanceBus'),
				},
			},

			// BUDGET
			offerPrice: {
				type: 'TextInput',
			},

			// PARTICIPANTS
			offerIncludesParticipants: {
				totalAmountOfParticipants: {
					type: 'NumberInput',
					label: getLabel('quoteRequest.offerIncludesParticipants.total'),
					min: 0,
					max: 1000,
					required,
					note: getLabel('quoteRequest.offerIncludesParticipants.description'),
				},
				amountOfParticipantsInSingleRooms: {
					type: 'NumberInput',
					label: getLabel('quoteRequest.offerIncludesParticipants.inSingleRooms'),
					min: 0,
					max: 500,
				},
				amountOfParticipantsInDoubleRooms: {
					type: 'NumberInput',
					label: getLabel('quoteRequest.offerIncludesParticipants.inDoubleRooms'),
					min: 0,
					max: 500,
				},
				amountOfParticipantsInMultiBedRooms: {
					type: 'NumberInput',
					label: getLabel('quoteRequest.offerIncludesParticipants.inMultiBedRooms'),
					min: 0,
					max: 500,
				},
			}
		},

		// NOTES
		description: {
			type: 'TextArea',
			maxLength: 250,
		},

		// CUSTOMER
		customer: {
			salutation: {
				type: "RadioGroup",
				options: [
					{value: getLabel('customer.salutation.Frau')},
					{value: getLabel('customer.salutation.Herr')},
					{value: getLabel('customer.salutation.Divers')},
				],
				required,
			},
			givenName: {
				type: "TextInput",
				required,
			},
			familyName: {
				type: "TextInput",
				required,
			},
			address: {
				contactType: {
					type: "RadioGroup",
					options: [
						{value: getLabel('customer.address.contactType.personal')},
						{value: getLabel('customer.address.contactType.official')},
					],
					required,
				},
				streetAddress: {
					type: "TextInput",
					required,
				},
				postalCode: {
					type: "TextInput",
					required,
				},
				addressLocality: {
					type: "TextInput",
					required,
				},
			},
			email: {
				type: "TextInput",
				required,
			},
			telephone: {
				type: "TextInput",
				required,
				pattern: /[0-9 \/\-\+\(\)]{4,}/,
			},
		},
		participant: {
			additionalType: {
				type: "Selectbox",
				options: [
					{value: getLabel('participant.additionalType.company')},
					{value: getLabel('participant.additionalType.society')},
					{value: getLabel('participant.additionalType.privateGroup')},
					{value: getLabel('participant.additionalType.other')},
				],
				hasEmptyOption: false,
			},
			name: {
				type: "TextInput",
			},
		},

		// REFERER
		referer: {
			type: "Selectbox",
			options: [
				{value: getLabel('referer.alreadyBooked')},
				{value: getLabel('referer.advertisement')},
				{value: getLabel('referer.recommendation')},
				{value: getLabel('referer.searchEngine')},
				{value: getLabel('referer.socialMedia')},
				{value: getLabel('referer.simpleTrain')},
				{value: getLabel('referer.podcast')},
				{value: getLabel('referer.catalogue')},
				{value: getLabel('referer.other')},
			],
			hasEmptyOption: false,
		},

		// NEWSLETTER
		newsletter: {
			type: "CheckboxGroup",
			options: [
				{value: getLabel('newsletter')},
			],
			label: '',
			note: getLabel('newsletter.description'),
		},
	};

	return {
		getConfig: (name: string) => ({
			name,
			label: getLabel(name),
			...get(fields, name, {})
		}),
		getLabel: (key: string) => {
			const label = get(LABEL, key, '');

			if (!label) {
				console.warn('Missing label for', key);
			}

			return label;
		},
	};
}
